import React from "react";
import {useHistory} from "react-router";
import PropTypes from "prop-types";
import {Trans, useTranslation} from "@unibuddy/intl";
import moment from "moment";

import {rootURL} from "shared/Utils/WhereAmI";
import s from "./ActivityStat.pcss";
import {useUser} from "../../../../modules/User/useUser";
import {IntlNamspaces} from "../../../../../translations/types";
import {INTL_ACTIVITY_STAT} from "../../../../../translations/common";

const getLaunchDate = (launchDate, t) => {
    if (launchDate) {
        const month = moment(launchDate).format("MMMM");
        const year = moment(launchDate).format("YYYY");

        return `${t(`months:${month}.long`, month)} ${year}`;
    }
    return t("launching", "launching");
};

const ActivityStat = ({uniLaunchDate, totalMessages, buddyGroupType}) => {
    const {t} = useTranslation([IntlNamspaces.COMMON, "months"]);
    const launchDate = getLaunchDate(uniLaunchDate, t);
    const buddyType = t(buddyGroupType, buddyGroupType);
    const user = useUser();
    const history = useHistory();

    return (
        <div id="activity-stat" className={s.activityStat}>
            <Trans
                t={t}
                i18nKey={INTL_ACTIVITY_STAT.key}
                launchDate={launchDate}
                totalMessages={totalMessages}
                buddyType={buddyType}
            >
                Since {{launchDate}},
                <a
                    className={s.number}
                    id="num-questions"
                    href={
                        user
                            ? `${rootURL(history.location.pathname)}/inbox`
                            : `${rootURL(history.location.pathname)}/auth`
                    }
                >
                    {" "}
                    {{totalMessages}}
                    {" questions "}
                </a>
                have been answered by our {{buddyType}}.
            </Trans>
        </div>
    );
};
ActivityStat.defaultProps = {
    buddyGroupType: "students",
};
ActivityStat.propTypes = {
    totalMessages: PropTypes.number.isRequired,
    uniLaunchDate: PropTypes.string.isRequired,
    buddyGroupType: PropTypes.string,
};

export default ActivityStat;
